"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_1 = require("../../../constants/data");
var Line_1 = require("../../chart/Charts/Line");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_i18next_1 = require("react-i18next");
var RelatorioAtendimentos = /** @class */ (function (_super) {
    __extends(RelatorioAtendimentos, _super);
    function RelatorioAtendimentos(props) {
        var _this = _super.call(this, props) || this;
        _this.parseMetrics = function (metricsData) {
            var metricsLabel = [];
            var mediaSolicitacoesAtendimento = [];
            var solicitacoesAtendimento = [];
            var atendimentosRealizados = [];
            var atendimentosNaoRealizados = [];
            metricsData === null || metricsData === void 0 ? void 0 : metricsData.map(function (metric, index) {
                var month = data_1.default.monthNames[parseInt(metric.Day.substr(4, 2), 10) - 1];
                var day = metric.Day.substr(6, 2).replace(/^0+/, '');
                metricsLabel.push(month + " " + day);
                mediaSolicitacoesAtendimento.push(metric.MediaSolicitacoesAtendimento);
                solicitacoesAtendimento.push(metric.SolicitacoesAtendimento);
                atendimentosRealizados.push(metric.AtendimentoRealizados);
                atendimentosNaoRealizados.push(metric.AtendimentoNaoRealizados);
            });
            return {
                label: metricsLabel,
                average: mediaSolicitacoesAtendimento,
                total: solicitacoesAtendimento,
                atendimentosRealizado: atendimentosRealizados,
                atendimentosNaoRealizados: atendimentosNaoRealizados,
            };
        };
        _this.localize = _this.props.t;
        _this.state = {
            activeTabId: 0,
            metrics: _this.props.metrics,
            chartData: {
                labels: _this.parseMetrics(_this.props.metrics).label,
                datasets: [
                    {
                        label: _this.localize("TotalSolicitacoes"),
                        data: _this.parseMetrics(_this.props.metrics).total,
                    },
                    {
                        label: _this.localize("MediaSolicitacoes"),
                        data: _this.parseMetrics(_this.props.metrics).average,
                    },
                    {
                        label: _this.localize("TotalAtendimentos"),
                        data: _this.parseMetrics(_this.props.metrics).atendimentosRealizado,
                        backgroundColor: "#23B24D",
                    },
                    {
                        label: _this.localize("TotalAtendimentosNaoRealizados"),
                        data: _this.parseMetrics(_this.props.metrics).atendimentosNaoRealizados,
                        backgroundColor: "#ED1B23",
                    },
                ],
            }
        };
        return _this;
    }
    RelatorioAtendimentos.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartData: {
                    labels: this.parseMetrics(this.props.metrics).label,
                    datasets: [
                        {
                            label: this.localize("TotalSolicitacoes"),
                            data: this.parseMetrics(this.props.metrics).total,
                        },
                        {
                            label: this.localize("MediaSolicitacoes"),
                            data: this.parseMetrics(this.props.metrics).average,
                        },
                        {
                            label: this.localize("TotalAtendimentos"),
                            data: this.parseMetrics(this.props.metrics).atendimentosRealizado,
                            backgroundColor: "#23B24D",
                        },
                        {
                            label: this.localize("TotalAtendimentosNaoRealizados"),
                            data: this.parseMetrics(this.props.metrics).atendimentosNaoRealizados,
                            backgroundColor: "#ED1B23",
                        },
                    ],
                }
            });
        }
    };
    RelatorioAtendimentos.prototype.setActiveTabId = function (index, item) {
        this.props.filter(parseInt(item.content.split(" ")[0]), index);
        this.setState({
            activeTabId: index
        });
    };
    RelatorioAtendimentos.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_northstar_1.Box, { className: "relatorioAtendimentos", styles: {
                display: "grid",
                gridGap: "1.2rem",
                gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(41.50rem, 1fr))",
                gridAutoFlow: "dense",
                gridAutoRows: "25rem 2rem",
                padding: "1rem 2rem",
                minWidth: "20rem",
                "@media (max-width: 986px)": {
                    gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                },
            } },
            React.createElement(react_northstar_1.Card.Header, null,
                React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                        React.createElement(react_northstar_1.Text, { content: this.localize("RelatorioAtendimentos"), style: { margin: 0 }, weight: "bold" })),
                    React.createElement(react_northstar_1.Popup, { align: "end", position: "below", open: false, onOpenChange: function () { return null; }, content: {
                            styles: { width: "12.5rem" },
                            content: (React.createElement(react_northstar_1.Menu, { items: undefined, vertical: true })),
                        }, trapFocus: {
                            firstFocusableSelector: ".extended-toolbar__filters-menu__tree [data-is-focusable=true]",
                        } }))),
            React.createElement(react_northstar_1.Card.Body, { style: {
                    height: "100%",
                    overflow: "hidden",
                }, fitted: true }, this.props.metrics ?
                React.createElement(React.Fragment, null,
                    React.createElement(react_northstar_1.Menu, { style: {
                            border: "none",
                            background: "none",
                            marginBottom: "1.25rem",
                        }, items: [
                            {
                                key: "7",
                                content: this.localize("7dias")
                            },
                            {
                                key: "30",
                                content: this.localize("30dias")
                            },
                            {
                                key: "60",
                                content: this.localize("60dias")
                            }
                        ], activeIndex: this.props.index, onItemClick: function (currentTarget, props) {
                            return _this.setActiveTabId(props && props.index ? props.index : 0, props);
                        }, accessibility: react_northstar_1.tabListBehavior, underlined: true, primary: true }),
                    React.createElement(react_northstar_1.Flex, { className: "chartRelatorioAtendimentos", styles: {
                            height: "100%",
                            width: "99%",
                            display: "flex",
                        }, column: true },
                        React.createElement(react_northstar_1.ProviderConsumer, { render: function (globalTheme) {
                                return (React.createElement(Line_1.default, __assign({}, {
                                    title: _this.localize("RelatorioAtendimentos"),
                                    data: _this.state.chartData,
                                    siteVariables: globalTheme.siteVariables
                                })));
                            } })))
                :
                    React.createElement("svg", { className: "emptyChart", viewBox: "0 0 18.777 18.777" },
                        React.createElement("path", { style: { fill: "#030104" }, d: "M2.245,10.496H0.272C0.122,10.496,0,10.62,0,10.77v5.717c0,0.15,0.122,0.272,0.272,0.272h1.973\r\n\t\t\t                    c0.15,0,0.272-0.122,0.272-0.272V10.77C2.518,10.62,2.396,10.496,2.245,10.496z" }),
                        React.createElement("path", { style: { fill: "#030104" }, d: "M18.504,10.496h-1.973c-0.15,0-0.271,0.124-0.271,0.274v5.717c0,0.15,0.121,0.272,0.271,0.272\r\n\t\t\t                    h1.973c0.152,0,0.273-0.122,0.273-0.272V10.77C18.777,10.62,18.656,10.496,18.504,10.496z" }),
                        React.createElement("path", { style: { fill: "#030104" }, d: "M5.907,7.228H3.934c-0.15,0-0.273,0.122-0.273,0.273v8.984c0,0.15,0.123,0.272,0.273,0.272h1.973\r\n\t\t\t                    c0.151,0,0.273-0.122,0.273-0.272V7.501C6.18,7.349,6.058,7.228,5.907,7.228z" }),
                        React.createElement("path", { style: { fill: "#030104" }, d: "M14.271,7.228h-1.973c-0.15,0-0.271,0.122-0.271,0.273v8.984c0,0.15,0.121,0.272,0.271,0.272h1.973\r\n\t\t\t                    c0.152,0,0.273-0.122,0.273-0.272V7.501C14.545,7.349,14.424,7.228,14.271,7.228z" }),
                        React.createElement("path", { style: { fill: "#030104" }, d: "M10.01,9.218H8.036c-0.15,0-0.272,0.123-0.272,0.272v6.994c0,0.15,0.122,0.272,0.272,0.272h1.974\r\n\t\t\t                    c0.152,0,0.273-0.122,0.273-0.272V9.49C10.283,9.341,10.162,9.218,10.01,9.218z" }),
                        React.createElement("path", { style: { fill: "#030104" }, d: "M1.259,6.947c0.581,0,1.051-0.47,1.051-1.051c0-0.101-0.019-0.196-0.046-0.288l2.211-1.591\r\n\t\t\t                    c0.136,0.064,0.286,0.102,0.446,0.102c0.309,0,0.583-0.135,0.776-0.347L7.784,4.98c-0.012,0.062-0.02,0.126-0.02,0.19\r\n\t\t\t                    c0,0.58,0.471,1.051,1.051,1.051c0.559,0,1.012-0.438,1.044-0.989l2.814-0.823c0.191,0.262,0.498,0.435,0.848,0.435\r\n\t\t\t                    c0.232,0,0.443-0.077,0.617-0.205l2.365,1.604c-0.02,0.083-0.037,0.17-0.037,0.26c0,0.581,0.471,1.052,1.051,1.052\r\n\t\t\t                    s1.053-0.471,1.053-1.052s-0.473-1.051-1.053-1.051c-0.232,0-0.443,0.077-0.617,0.204l-2.363-1.601\r\n\t\t\t                    c0.02-0.084,0.035-0.17,0.035-0.26c0-0.581-0.469-1.051-1.051-1.051c-0.559,0-1.012,0.438-1.045,0.989L9.663,4.555\r\n\t\t\t                    C9.472,4.292,9.164,4.12,8.815,4.12c-0.259,0-0.492,0.096-0.675,0.251L5.968,3.112c0-0.015,0.004-0.028,0.004-0.042\r\n\t\t\t                    c0-0.581-0.47-1.052-1.051-1.052S3.87,2.488,3.87,3.069c0,0.158,0.038,0.306,0.1,0.441L1.855,5.032\r\n\t\t\t                    C1.686,4.914,1.481,4.845,1.259,4.845c-0.581,0-1.051,0.471-1.051,1.051C0.208,6.477,0.678,6.947,1.259,6.947z" })))));
    };
    return RelatorioAtendimentos;
}(React.Component));
var relatorioAtendimentosWithTranslation = react_i18next_1.withTranslation()(RelatorioAtendimentos);
exports.default = relatorioAtendimentosWithTranslation;
//# sourceMappingURL=relatorio-atendimentos.js.map